import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

const GoogleAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        if (!GA_TRACKING_ID) {
            console.error("Google Analytics tracking ID is missing.");
            return;
        }

        // Load Google Analytics script
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
        script.async = true;
        document.head.appendChild(script);

        // Initialize gtag and dataLayer
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        window.gtag('js', new Date());
        window.gtag('config', GA_TRACKING_ID, {
            page_path: window.location.pathname,
        });

        window.gtag('config', GA_TRACKING_ID, {
            page_path: location.pathname,
        });
    }, [location.pathname]);

    return null;
};

export default GoogleAnalytics;
